// Core
import React from "react";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Custom components
import Button from "Components/Button";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-root-container">
      <h1 className="not-found-heading">404</h1>
      <p className="not-found-sub-heading">Page Not Found</p>
      <p className="not-found-message">
        Oops! The page you're looking for doesn't exist.
      </p>
      <Button
        title="Go Back to Home"
        buttonStyle={{ width: "50%" }}
        onClick={() => navigate("/")}
      />
    </div>
  );
};

export default NotFound;
